import React from 'react'
import { Stack, TextField, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import SignupSubmitButton from './SignupSubmitButton'

interface SsoNameStepProps {
    email: string
    nameGiven: string
    nameFamily: string
    onNameGivenChange: (value: string) => void
    onNameFamilyChange: (value: string) => void
    nameGivenErrorMessage?: string
    nameFamilyErrorMessage?: string
    submitting: boolean
}

const SsoNameStep: React.FC<SsoNameStepProps> = ({
    email,
    nameGiven,
    nameFamily,
    onNameGivenChange,
    onNameFamilyChange,
    nameGivenErrorMessage,
    nameFamilyErrorMessage,
    submitting,
}) => {
    const { t } = useTranslation()

    return (
        <>
            <Typography variant="body2" align="center" color="text.secondary">
                {t('signup.email_verified', { email })}
            </Typography>
            <Stack direction="row" spacing={1}>
                <TextField
                    fullWidth
                    // eslint-disable-next-line jsx-a11y/no-autofocus -- first field of a fresh step
                    autoFocus
                    label={t('signup.first_name_label')}
                    autoComplete="given-name"
                    value={nameGiven}
                    error={!!nameGivenErrorMessage}
                    helperText={nameGivenErrorMessage}
                    onChange={(e) => onNameGivenChange(e.target.value)}
                />
                <TextField
                    fullWidth
                    label={t('signup.last_name_label')}
                    autoComplete="family-name"
                    value={nameFamily}
                    error={!!nameFamilyErrorMessage}
                    helperText={nameFamilyErrorMessage}
                    onChange={(e) => onNameFamilyChange(e.target.value)}
                />
            </Stack>
            <SignupSubmitButton disabled={submitting || !nameGiven || !nameFamily}>
                {t('signup.create_button')}
            </SignupSubmitButton>
        </>
    )
}

export default SsoNameStep
